import React from 'react';
import TableBody from './TableBody';

const TableList = props => {
    //Tomo los props
    const { prefix, headers, items, state } = props;
    //Renderizo
    return (
        <div className="table-responsive">
            <table className="table table-bordered table-sm" id="dataTable" width="100%" cellSpacing="0">
                <thead className="thead-light">
                    <tr>
                        {
                            headers.map((header, index) => (
                                <th
                                    key={`h${prefix}${index}`}
                                    width={header.width}
                                >
                                    { header.name }
                                </th>
                            ))
                        }
                    </tr>
                </thead>
                <tbody>
                    <TableBody
                        prefix={prefix}
                        headers={headers}
                        items={items}
                        state={state}
                    />
                </tbody>
            </table>
        </div>
    );
};

export default TableList;